import React from 'react'
import * as S from './styled'
import { ResponsiveImage } from '../../ResponsiveImage'

const NewsAndBlog = () => {
  return (
    <S.Wrapper>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <S.WrapCard>
              <S.Title>Novinky</S.Title>
              <S.UnderlineYellow />
              <S.Card>
                <S.Subtitle>
                  Sužují Vaši firmu existenční problémy? Účetnictví Vám ukáže,
                  jak z krize ven
                </S.Subtitle>
                <S.WrapTextAndImage>
                  <ResponsiveImage src="/images/homepage/blog.png" />
                  <S.paragraph>
                    Prochází Vaše firma náročným obdobím? Pak to rozhodně
                    neberte jako záminku k tomu, abyste zanedbávali
                    administrativu kolem účetnictví a doufali, že na Vás
                    nepřijde kontrola.
                  </S.paragraph>
                </S.WrapTextAndImage>
                <S.ButtonWrap>
                  <S.Button>Více</S.Button>
                </S.ButtonWrap>
              </S.Card>
            </S.WrapCard>
          </div>
          <div className="col-md-6">
            <S.WrapCard>
              <S.Title>Blog</S.Title>
              <S.UnderlineYellow />
              <S.Card>
                <S.Subtitle>
                  Sužují Vaši firmu existenční problémy? Účetnictví Vám ukáže,
                  jak z krize ven
                </S.Subtitle>
                <S.WrapTextAndImage>
                  <ResponsiveImage src="/images/homepage/blog.png" />
                  <S.paragraph>
                    Prochází Vaše firma náročným obdobím? Pak to rozhodně
                    neberte jako záminku k tomu, abyste zanedbávali
                    administrativu kolem účetnictví a doufali, že na Vás
                    nepřijde kontrola.
                  </S.paragraph>
                </S.WrapTextAndImage>
                <S.ButtonWrap>
                  <S.Button>Více</S.Button>
                </S.ButtonWrap>
              </S.Card>
            </S.WrapCard>
          </div>
        </div>
      </div>
    </S.Wrapper>
  )
}

export default NewsAndBlog
